const M = [
  {
    name: "myOrder",
    zh: "我的订单",
    en: "My order"
  },
  {
    name: "locating",
    zh: "定位中...",
    en: "Locating"
  },
  {
    name: "locatingFailed",
    zh: "定位失败",
    en: "Locating failed"
  },
  {
    name: "enterMerchantCommodity",
    zh: "输入商家、商品名称",
    en: "Enter the name of the merchant and commodity"
  },
  {
    name: "recommendMerchant",
    zh: "推荐商家",
    en: "Recommend merchant"
  },
  {
    name: "nearbyMerchant",
    zh: "附近商家",
    en: "Nearby merchant"
  },
  {
    name: "enterProductSearch",
    zh: "输入商品名称搜索",
    en: "Enter the product name to search"
  },
  {
    name: "moreDiscount",
    zh: "更多优惠",
    en: "More discount"
  },
  {
    name: "deliverable",
    zh: "可配送",
    en: "Deliverable"
  },
  {
    name: "freeDelivery",
    zh: "起送",
    en: "Free delivery"
  },
  {
    name: "deliveryFee",
    zh: "配送费",
    en: "Delivery fee"
  },
  {
    name: "packingFee",
    zh: "包装费",
    en: "Packing fee"
  },
  {
    name: "notice",
    zh: "公告",
    en: "Notice"
  },
  {
    name: "order",
    zh: "点餐",
    en: "Order"
  },
  {
    name: "evaluate",
    zh: "评价",
    en: "Evaluate"
  },
  {
    name: "merchantReply",
    zh: "商家回复",
    en: "Merchant reply"
  },
  {
    name: "merchant",
    zh: "商家",
    en: "Merchant"
  },
  {
    name: "merchantName",
    zh: "商家名称",
    en: "Merchant name"
  },
  {
    name: "merchantAddress",
    zh: "商家地址",
    en: "Merchant address"
  },
  {
    name: "merchantNumber",
    zh: "商家电话",
    en: "Merchant phone number"
  },
  {
    name: "openingHours",
    zh: "营业时间",
    en: "Opening hours"
  },
  {
    name: "merchantAnnouncement",
    zh: "商家公告",
    en: "Merchant announcement"
  },
  {
    name: "merchantPicture",
    zh: "商家图片",
    en: "Merchant picture"
  },
  {
    name: "businessQualification",
    zh: "营业资质",
    en: "Business qualification"
  },
  {
    name: "commodityDetails",
    zh: "商品详情",
    en: "Commodity detail"
  },
  {
    name: "monthSold",
    zh: "月售",
    en: "Month sold"
  },
  {
    name: "total",
    zh: "合计：",
    en: "Total:"
  },
  {
    name: "discounted",
    zh: "已优惠：",
    en: "Discounted:"
  },
  {
    name: "submitOrder",
    zh: "提交订单",
    en: "Submit Order"
  },
  {
    name: "unfold",
    zh: "展开",
    en: "Unfold"
  },
  {
    name: "fold",
    zh: "收起",
    en: "Fold"
  },
  {
    name: "payOrder",
    zh: "支付订单",
    en: "Pay Order"
  },
  {
    name: "remainingTimePay",
    zh: "支付剩余时间",
    en: "Remaining time of payment"
  },
  {
    name: "orderDetail",
    zh: "订单详情",
    en: "Order detail"
  },
  {
    name: "noPayTips",
    zh: "请尽快支付，15分钟内未支付，订单将自动取消",
    en:
      "Pay as soon as possible. If you fail to pay within 15 minutes, the order will be cancelled automatically"
  },
  {
    name: "cancelOrder",
    zh: "取消订单",
    en: "Cancel order"
  },
  {
    name: "cancelOrderTips",
    zh: "确定取消订单？",
    en: "Are you sure to cancel the order?"
  },
  {
    name: "thinkAgain",
    zh: "再想想",
    en: "Think again"
  },
  {
    name: "contactMerchant",
    zh: "联系商家",
    en: "Contact merchant"
  },
  {
    name: "contactDeliver",
    zh: "联系骑手",
    en: "Contact deliver"
  },
  {
    name: "orderEvaluation",
    zh: "评价订单",
    en: "Order evaluation"
  },
  {
    name: "anonymousEvaluation",
    zh: "匿名评价",
    en: "Anonymous evaluation"
  },
  {
    name: "enterEvaluation",
    zh: "请输入您的评价",
    en: "Enter evaluation"
  },
  {
    name: "submitReview",
    zh: "提交评价",
    en: "Submit"
  },
  {
    name: "oneMoreOrder",
    zh: "再来一单",
    en: "One more order"
  },
  {
    name: "refunded",
    zh: " 已退款",
    en: "Refunded"
  },
  {
    name: "shippingInfo",
    zh: "配送信息",
    en: "Shipping information"
  },
  {
    name: "shippingAddress",
    zh: "配送地址",
    en: "Shipping address"
  },
  {
    name: "deliveryMethod",
    zh: "配送方式",
    en: "Delivery method"
  },
  {
    name: "deliveryman",
    zh: "配送员",
    en: "Deliveryman"
  },

  {
    name: "orderInfo",
    zh: "订单信息",
    en: "Order information"
  },
  {
    name: "orderNumber",
    zh: "订单号码",
    en: "Order number"
  },
  {
    name: "orderTime",
    zh: "下单时间",
    en: "Order time"
  },
  {
    name: "termsPayment",
    zh: "支付方式",
    en: "Payment type"
  },
  {
    name: "orderNote",
    zh: "订单备注",
    en: "Order note"
  },
  {
    name: "orderTimeout",
    zh: "订单超时",
    en: "Order timeout"
  },
  {
    name: "orderTimeoutPlaceNewOrder",
    zh: "订单已超时，请重新下单",
    en: "Order has timeout, please place a new order"
  },
  {
    name: "orderHasTimeout",
    zh: "订单已超时",
    en: "Order has timeout"
  }
];

export default M;
